// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Q1-z","displaySixCardTiles":"R1-z"};